<template>
  <div id="header">
    <b-navbar toggleable="md" type="dark" class="hamburger">
      <b-navbar-brand :to="{name: 'homepage'}" ><img src="../../static/image/logo-ballerio-white2.png"/></b-navbar-brand>
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav style="width: 100%">
          <b-nav-item
            href="https://camperwine.it/#/winetour"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{$t("cellar")}}
          </b-nav-item>
          <b-nav-item
            href="https://camperwine.it/#/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{$t("hospitality")}}
          </b-nav-item>
          <b-nav-item
            :to="{name: 'territorio'}"
          >
            {{$t("territory")}}
          </b-nav-item>

<!--          <b-nav-item-dropdown :text="$t('acteve')" extra-toggle-classes="nav-link-custom" right>-->
<!--            <b-dropdown-item :to="{name: 'attivita'}">{{$t("activities")}}</b-dropdown-item>-->
<!--            <b-dropdown-item :to="{name: 'events'}">{{$t("events")}}</b-dropdown-item>-->
<!--          </b-nav-item-dropdown>-->

          <!-- <b-nav-item-dropdown :text="$t('hospitality')" extra-toggle-classes="nav-link-custom" >
            <b-dropdown-item :to="{name: 'ospitalita'}">{{$t("reserve")}}</b-dropdown-item>
            <b-dropdown-item :to="{name: 'territorio'}">{{$t("territory")}}</b-dropdown-item>
          </b-nav-item-dropdown> -->

          <b-nav-item href="https://shop.tenutaballerio.com/" target="_blank">{{$t("shop")}}</b-nav-item>

          <!--<b-nav-item :to="{name: 'shop'}">Shop</b-nav-item>-->
<!--          <b-nav-item href="https://terredispirito.it/" target="_blank"><b>Shop</b></b-nav-item>-->

          <b-nav-item @click="changeLang()">Ita/Eng</b-nav-item>
          <div style="display: inline-flex">
            <b-nav-item id="webcam" @click="showLiveModal = true"><img
              src="../../static/image/webcam.svg"/></b-nav-item>
            <span class="social-separator"></span>
            <b-nav-item href="https://www.facebook.com/tenutaballerio" target="_blank" id="face"><img
              src="../../static/image/facebook.svg"/></b-nav-item>
            <b-nav-item href="https://www.instagram.com/TenutaBallerio/" target="_blank" id="insta"><img
              src="../../static/image/instagram.svg"/></b-nav-item>
          </div>
          <b-nav-item :to="{name: 'admin'}" v-if="getToken()">
            <img src="../../static/image/admin/admin2.png" id="car">
          </b-nav-item>
         <!-- <b-nav-item :to="{name: 'carrello'}">
            <div class="detailcar">
              <img src="../../static/image/carrello.png" id="car">
              <span class="numprod">{{total}}</span>
            </div>
          </b-nav-item>-->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <live-meteo-modal v-model="showLiveModal"></live-meteo-modal>
  </div>
</template>

<script>
  import Bus from './Bus'
  import LiveMeteoModal from './LiveMeteoModal'

  export default {
    name: 'HeaderPage',
    components: {
      LiveMeteoModal
    },
    data() {      return {
        cart: [],
        total: 0,
        showLiveModal: false
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          cellar: 'Degustazioni',
          activities: 'Attività',
          events: 'Eventi',
          hospitality: 'Ospitalità',
          shop: 'Shop vini',
          wines: 'Vini',
          acteve: 'Attività ed Eventi',
          reserve: 'I nostri Alloggi',
          territory: 'Scopri il territorio'
        },
        en: {
          cellar: 'Wine Tour',
          activities: 'Activities',
          events: 'Events',
          hospitality: 'Hospitality',
          shop: 'Wine shop',
          wines: 'Wines',
          acteve: 'Activity and Events',
          reserve: 'Our Accommodations',
          territory: 'Discover the area'
        }
      }
    },
    updated: function () {
      window.addEventListener('resize', this.getPageHeight)
    },
    mounted: function () {
      Bus.$on('totale', this.totCart)
      Bus.$on('azzeraCart',this.azzeraCart)
      Bus.$on('admin', () => {
        this.getToken()
        this.$forceUpdate()
      })
    },
    methods: {
      getPageHeight: function (event) {
        this.pageHeight = window.innerHeight
      },
      changeLang: function () {
        this.$root.$i18n.locale = this.$root.$i18n.locale === 'it' ? 'en' : 'it'
        this.$route.params.language = this.$root.$i18n.locale === 'it' ? 'ita' : 'eng'
      },
      getToken: function () {
        if (localStorage.getItem('token')) {
          return true
        } else {
          return false
        }
      },
      azzeraCart: function () {
        return this.total = 0
      },
      totCart: function (val) {
        return this.total = val
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;
    .hamburger {
      z-index: 5;
      position: absolute;
      background: linear-gradient(to bottom, #000000 40%, rgba(0, 0, 0, 0) 100%);
      width: 100%;
      //height: 70px;
      .navbar-nav {
        justify-content: space-around;
      }
      .dropdown-menu {
        /*background: linear-gradient(to bottom, #000000 40%, rgba(0, 0, 0, 0) 100%);*/
        background-color: @lightBlack;
        border: 0px;
        .dropdown-item {
          /*background: linear-gradient(to bottom, #000000 40%, rgba(0, 0, 0, 0) 100%);*/
          background-color: @lightBlack;
          border: none !important;
        }
        .dropdown-item a {
          border: none !important;
        }
      }

      #insta {
        .nav-link {
          padding-left: 0px;
        }
      }
      #webcam img,
      #face img,
      #insta img {
        width: 24px;
        height: 24px;
      }
      .social-separator {
        align-self: center;
        width: 2px;
        height: 24px;
        background-color: rgba(255, 255, 255, 0.5);
        margin: 0 8px;
      }
      .detailcar {
        text-align: right;
        width: 45px;
        position: relative;
        #car {
          position: relative;
          width: 45px;
        }
        .numprod {
          position: absolute;
          right: 3px;
          top: -5px;
          width: 35px;
          text-align: center;
          .set-font-latoLight(@size: 18px, @weight: bold, @color: orange);
        }
      }
      .nav-link {
        .set-font-header(@size: 16px);
      }
    }

    .navbar-collapse:after, .navbar-collapse:before {
      background-color: rgba(255, 0, 0, 0.0);
    }
    .dropdown-item:hover {
      a:hover {
        border: none !important;
      }
    }
  }

  @media (max-width: 767px) {
    #header {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 5;
      .hamburger {
        /*padding: 0px !important;*/
      }
      .navbar-dark {
        .navbar-brand {
          margin: auto;
          padding-left: 20px;
          width: 200px!important;
        }
        .navbar-toggler {
          margin: 5px;
        }
      }
      .navbar-collapse {
        background-color: #202127;
      }
      .hamburger {
        background: initial;
        background-color: #202127;
        .navbar-nav {
          padding-left: 20px;
        }
        .dropdown-menu {
          .set-font(@size: 14px);
        }
        .nav-link {
          .set-font(@size: 14px)
        }
        .detailcar {
          text-align: right;
          padding-left: 0px;
          #car {
            position: relative;
            width: 45px;
          }
          .numprod {
            position: absolute;
            right: 3px;
            top: -5px;
            width: 35px;
            text-align: center;
            .set-font-latoLight(@size: 18px, @weight: bold, @color: orange);
          }
        }
        #face {
          .nav-link {
            padding-right: 10px;
          }
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    #header {
      .hamburger {
        .nav-link {
          .set-font-header(@size: 14px);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderPage.vue